var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListedForSale(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#D85263"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#D85263"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8845_2565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8422 6.80739L15.8889 6.12649C15.826 6.08465 15.7422 6.05314 15.6585 6.05314H6.23058V5.25705C6.23058 5.17327 6.19917 5.08949 6.14679 5.02657L5.42395 4.13616C5.3506 4.05238 5.23541 4 5.12022 4C5.00493 4 4.88974 4.05238 4.81639 4.1467L4.09355 5.03711C4.04117 5.09992 4.00977 5.1837 4.00977 5.26749V16.6229C4.00977 16.8324 4.17743 17 4.39738 17H5.8535C6.06301 17 6.24101 16.8324 6.24101 16.6229V8.15876H9.22651V9.44722H7.82286C7.63432 9.44722 7.48763 9.60435 7.48763 9.78245V14.3497C7.48763 14.5382 7.64476 14.6849 7.82286 14.6849H14.7261C14.9147 14.6849 15.0613 14.5278 15.0613 14.3497V9.78245C15.0613 9.59392 14.9042 9.44722 14.7261 9.44722H13.6786V8.15876H15.6585C15.7422 8.15876 15.8156 8.13779 15.8889 8.08542L16.8422 7.40451C16.9365 7.33116 16.9993 7.22641 16.9993 7.10068C16.9993 6.9855 16.9365 6.88074 16.8422 6.80739ZM9.68747 9.44722V8.15876H13.2072V9.44722H9.68747Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8845_2565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListedForSale);
export default __webpack_public_path__ + "static/media/listed-for-sale.7492b2f23dc7163fb63c6d6ba67673a3.svg";
export { ForwardRef as ReactComponent };